import PositiveIndicatorTable from 'components/prism/positiveIndicatorTable';
import { Modal, SystemText } from 'e4shared';
import React from 'react';

export const PISummary = ({ show, close }) => {
    const [data, setData] = React.useState([]);

    React.useEffect(() => {
        if (show) {
            setData(show.positiveIndicators);
        }
    }, [show]);

    return (
        <Modal show={show} title={SystemText('Reviews/Measure/Title')} close={close} footer={null}>
            <p>{SystemText('Reviews/Measure/Summary')}</p>
            <PositiveIndicatorTable data={data} />
        </Modal>
    );
};

export default PISummary;
